export default function shouldRefreshExtraAttacksAfterReaction({
  toggleExtras = false,
  arenaExtraReady = false,
  arenaExtraAction = 0,
  viewRound = null,
  arenaRound = null,
} = {}) {
  return viewRound === arenaRound && arenaExtraReady === true
}
